import React, { useEffect } from 'react'

function AboutUs() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
  });
  }, []);
  return (
    <div style={{ margin: 20 }}>
      <h2>About Us</h2>
      <p className='footer-text'>Welcome to "onlinegoodnews.com" - your own online platform for sharing Hope, Inspiration, and Uplifting stories from around the Globe. We are dedicated in delivering content rooted in faith and positive values that inspire and unite Christians of all backgrounds.</p>
      <p className='footer-text'>Our mission is to create a space where everyone—believers, seekers, and those simply curious—can discover stories of hope, love, and resilience. By shining a spotlight on the great happenings in communities and beyond, we strive to be a source of light in a world often overshadowed by negativity.</p>
      <p className='footer-text'>To provide news and insights about churches and missions worldwide, fostering growth, unity, and encouragement, all for the greater glory of God.</p>
      <p className='footer-text'>In all that we do, across every platform, we strive to provide a deeper experience that is very much rooted in faith thoughtfully designed and creatively inspired, driven the love of Christ and His Church.</p>
      <h3>Our Team</h3>
      <p className='footer-text'>Online Goodnews is powered by seasoned professionals with over four decades of expertise in Christian journalism and communications, committed to sharing stories that inspire, connect, and inform a global audience.</p>
      <ul>
        <li> <p className='footer-text'>C V Mathew</p></li>
        <li> <p className='footer-text'>T M Mathew</p></li>
        <li> <p className='footer-text'>Shaji Maniyat</p></li>
        <li> <p className='footer-text'>Wesly Mathew</p></li>
        <li> <p className='footer-text'>Saji Mathai Kathettu</p></li>
        <li> <p className='footer-text'>Jessy Shajan</p></li>
        <li> <p className='footer-text'>Finny Korah</p></li>
      </ul>
      <h3>Contact Us</h3>
      <p className='footer-text'>We value your feedback and are here to assist you with any questions or inquiries. Feel free to reach out to us through the following contact details:</p>
      <p className='footer-text'><strong>Address:</strong> ONLINEGOODNEWS.COM, Kottayam 686 004, Kerala, India</p>
      <p className='footer-text'><strong>Phone:</strong></p>
      <ul>
        <li> <p className='footer-text'>India: +91 94473 72726 / +91 99462 05422 / +91 94005 20909</p></li>
        <li> <p className='footer-text'>USA: +1 (214) 929 7614</p></li>
        <li> <p className='footer-text'>UK: +44 7951 963062</p></li>
        <li> <p className='footer-text'>Australia: +61 420640472</p></li>
        <li> <p className='footer-text'>Gulf: +971 50 354 0676</p></li>
      </ul>
      <p className='footer-text'><strong>Email:</strong> <a href="mailto:info@onlinegoodnews.com">info@onlinegoodnews.com</a></p>
    </div>
  )
}

export default AboutUs;